import { GET_KYC_LISTING_FORM } from "../../../Types";

const KYCListingFormReducer = (state = [], action) => {
  switch (action.type) {
    case GET_KYC_LISTING_FORM:
      return action.payload;
    default:
      return state;
  }
};

export default KYCListingFormReducer;
